import {useEffect, useState} from "react";
import {Button, Col, Divider, Form, Input, message, Radio, Row, Select, Space} from "antd";
import {CustomerWrapperDto} from "../../dto/CustomerWrapperDto";
import {IncomeDetailDto} from "../../dto/IncomeDetailDto";
import Validation from "../../util/Validation";
import {InputDropdownParameterDto} from "../../dto/InputDropdownParameterDto";
import {
    ALPHANUMERIC_AND_NUMBER_VALIDATION,
    COMMON_DROPDOWN,
    OCCUPATION_VALIDATION,
    PARAMETER_LIST
} from "../../util/Constants";
import {DropdownListDto} from "../../dto/DropdownListDto";
import TextArea from "antd/es/input/TextArea";
import customerService from "../../service/customerService";
import {MSG_FAILED_TO_FETCH_COMMON_DROPDOWN_TYPES_ERROR} from "../../util/Messages";
import ErrorHandler from "../../util/ErrorHandler";

import {step_3_inactive_img} from '../../../AppImageConst';
import CommonFunction from "../../util/CommonFunction";

const {Option} = Select;

interface OccupationDetailsPropData {
    savedCusDetailFromPreviousStep: CustomerWrapperDto
    getStepperFilledData: (data: CustomerWrapperDto) => void,
    switchStep?: () => void,
    isFromSummaryView: boolean
}

const OccupationDetails = (props: OccupationDetailsPropData) => {
    const [form] = Form.useForm();

    const [investmentObjective, setInvestmentObjective] = useState<DropdownListDto[]>([]);
    const [sourcesOfFunds, setSourcesOfFunds] = useState<DropdownListDto[]>([]);
    const [annualIncome, setAnnualIncome] = useState<DropdownListDto[]>([]);
    const [isInvestmentObjRemark, setIsInvestmentObjRemark] = useState(false);
    const [isSourceOfFUndRemark, setIsSourceOfFUndRemark] = useState(false);
    const [isFieldsMandatory, setFieldsMandatory] = useState(false);

    const [initialInvestmentAmt, setInitialInvestmentAmt] = useState<number>(0);
    const [expectedFutureInvestment, setExpectedFutureInvestment] = useState<number>(0);


    useEffect(() => {
        window.scrollTo(0, 0)
        if (props.savedCusDetailFromPreviousStep.customerMstDto?.incomeDetail) {
            setInitialValues(props.savedCusDetailFromPreviousStep.customerMstDto.incomeDetail)
        }
        getCommonDropdownList();
    }, [])
    const setInitialValues = (incomeDetail: IncomeDetailDto) => {
        setFieldsMandatory(1 == incomeDetail.sourceOfWealthId || 2 == incomeDetail.sourceOfWealthId)

        setIsInvestmentObjRemark(incomeDetail.investmentObjectiveID == 8)
        setIsSourceOfFUndRemark(incomeDetail.sourceOfWealthId == 5)
        setInitialInvestmentAmt(incomeDetail.initialInvestmentAmount)
        setExpectedFutureInvestment(incomeDetail.expectedFutureInvestmentAmount)
        form.setFieldsValue(
            {
                tinNo: incomeDetail.tinNo,
                addressOfEmployer: incomeDetail.addressOfEmployer,
                natureOfBusiness: incomeDetail.natureOfBusiness,
                otherInvestmentObjective: incomeDetail.otherInvestmentObjective,
                otherSourceOfWealth: incomeDetail.otherSourceOfWealth,
                nameOfEmployer: incomeDetail.nameOfEmployer,
                occupation: incomeDetail.occupation,
                annualIncomeId: incomeDetail.annualIncomeId,
                sourceOfWealthId: incomeDetail.sourceOfWealthId,
                expectedFutureInvestmentAmount: CommonFunction.currencyFormat(incomeDetail.expectedFutureInvestmentAmount),
                initialInvestmentAmount: CommonFunction.currencyFormat(incomeDetail.initialInvestmentAmount),
                investmentObjectiveID: incomeDetail.investmentObjectiveID
            }
        )
    }

    const submitThirdStep = (values: IncomeDetailDto) => {
        let updatedIncomeDetailDto: IncomeDetailDto = values;

        let customerWrapperDto = props.savedCusDetailFromPreviousStep;

        // customerWrapperDto.completedStep = PageStep.STEP_OCCUPATION_INVESTMENT_DETAIL
        // customerWrapperDto.currentActiveStep = PageStep.STEP_OCCUPATION_INVESTMENT_DETAIL

        updatedIncomeDetailDto.expectedFutureInvestmentAmount = CommonFunction.removeCommaSeparators(expectedFutureInvestment)
        updatedIncomeDetailDto.initialInvestmentAmount = CommonFunction.removeCommaSeparators(initialInvestmentAmt)
        customerWrapperDto.recordStatus = "UPDATE"
        customerWrapperDto.isFinalStep = false

        if (props.savedCusDetailFromPreviousStep.customerMstDto.incomeDetail) {
            if (checkForFieldChanges(props.savedCusDetailFromPreviousStep.customerMstDto.incomeDetail, values)) {
                updatedIncomeDetailDto.id = props.savedCusDetailFromPreviousStep.customerMstDto.incomeDetail.id;
                updatedIncomeDetailDto.otherInvestmentObjective = isInvestmentObjRemark ? values.otherInvestmentObjective : null
                updatedIncomeDetailDto.otherSourceOfWealth = isSourceOfFUndRemark ? values.otherSourceOfWealth : null

                customerWrapperDto.currentActiveStep = customerWrapperDto.completedStep
                customerWrapperDto.customerMstDto.incomeDetail = updatedIncomeDetailDto;
                props.getStepperFilledData(customerWrapperDto)

            } else {
                console.log("just switch the step")
                if (props.switchStep) props.switchStep()
            }
        } else {
            updatedIncomeDetailDto.otherInvestmentObjective = isInvestmentObjRemark ? values.otherInvestmentObjective : ''
            updatedIncomeDetailDto.otherSourceOfWealth = isSourceOfFUndRemark ? values.otherSourceOfWealth : ''
            customerWrapperDto.customerMstDto.incomeDetail = updatedIncomeDetailDto;

            props.getStepperFilledData(customerWrapperDto)
        }
    }

    const checkForFieldChanges = (curValue: IncomeDetailDto, formValue: IncomeDetailDto) => {

        formValue.otherInvestmentObjective = formValue.investmentObjectiveID != 8 ? null : formValue.otherInvestmentObjective
        formValue.otherSourceOfWealth = formValue.sourceOfWealthId != 5 ? null : formValue.otherSourceOfWealth

        return (
            curValue.investmentObjectiveID !== formValue.investmentObjectiveID ||
            curValue.initialInvestmentAmount !== formValue.initialInvestmentAmount ||
            curValue.sourceOfWealthId !== formValue.sourceOfWealthId ||
            curValue.annualIncomeId !== formValue.annualIncomeId ||
            curValue.occupation !== formValue.occupation ||
            curValue.nameOfEmployer !== formValue.nameOfEmployer ||
            curValue.expectedFutureInvestmentAmount !== formValue.expectedFutureInvestmentAmount ||

            curValue.otherSourceOfWealth !== formValue.otherSourceOfWealth ||
            curValue.otherInvestmentObjective !== formValue.otherInvestmentObjective ||

            curValue.otherSourceOfWealth !== formValue.otherSourceOfWealth ||
            curValue.otherInvestmentObjective !== formValue.otherInvestmentObjective ||
            curValue.natureOfBusiness !== formValue.natureOfBusiness ||
            curValue.addressOfEmployer !== formValue.addressOfEmployer ||
            curValue.tinNo !== formValue.tinNo
        );
    }
    const getCommonDropdownList = () => {
        const inputDropdownParameterDto: InputDropdownParameterDto[] = [
            {
                dropdownDataSourceId: COMMON_DROPDOWN.INVESTMENT_OBJECTIVE,
                findTextValue: "",
                parameterList: [PARAMETER_LIST.ACTIVE]
            },
            {
                dropdownDataSourceId: COMMON_DROPDOWN.SOURCE_OF_FUND,
                findTextValue: "",
                parameterList: [PARAMETER_LIST.ACTIVE]
            },
            {
                dropdownDataSourceId: COMMON_DROPDOWN.ANNUAL_INCOME,
                findTextValue: "",
                parameterList: [PARAMETER_LIST.ACTIVE]
            },
        ]
        loadCommonDropdownDataList(inputDropdownParameterDto);
    }
    const loadCommonDropdownDataList = (dropDownParameterDto: InputDropdownParameterDto[]) => {
        customerService.getCommonDropdownList(dropDownParameterDto).then(res => {
            if (res.data !== null) {

                let dropdownDataList = res.data.results.dropdownDataList;
                setInvestmentObjective(dropdownDataList[COMMON_DROPDOWN.INVESTMENT_OBJECTIVE])
                setSourcesOfFunds(dropdownDataList[COMMON_DROPDOWN.SOURCE_OF_FUND])
                setAnnualIncome(dropdownDataList[COMMON_DROPDOWN.ANNUAL_INCOME])

            } else {
                message.error(MSG_FAILED_TO_FETCH_COMMON_DROPDOWN_TYPES_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }
    const onChangeInvestmentObj = (val: number) => {
        if (8 == val) {
            setIsInvestmentObjRemark(true)
        } else {
            setIsInvestmentObjRemark(false)
        }
    }
    const onChangeSourceOfFund = (val: number) => {
        if (1 == val || 2 == val) {
            setFieldsMandatory(true)

            setIsSourceOfFUndRemark(false)
        } else {
            form.validateFields()
            setFieldsMandatory(false)
            if (5 == val) {
                setIsSourceOfFUndRemark(true)
            } else {
                setIsSourceOfFUndRemark(false)
            }
        }

    }
    const onChangeInitialInvestmentAmt = (e: any) => {
        setInitialInvestmentAmt(CommonFunction.removeCommaSeparators(e.target.value))

    }
    const onChangeExpectedFutureInvestment = (e: any) => {
        setExpectedFutureInvestment(CommonFunction.removeCommaSeparators(e.target.value))
    }

    const toFixedMethod = (name: string) => {
        if (undefined != name) {
            let val = form.getFieldValue(name);
            if (val) {
                val = !CommonFunction.checkThousandSeparated(val) ? val.toString() : CommonFunction.removeThousandSeparators(val);
                let jsonData: any = {};
                if (val.indexOf(".") != -1) {
                    val = val.slice(0, (val.indexOf(".")) + 3);
                }
                jsonData[name] = CommonFunction.currencyFormat(val)
                form.setFieldsValue(jsonData);
            }
        }
    }

    return (
        <div>
            <p className='step_card_header'>
                <div className="icon-container">
                    <img className='header-icon-img' src={step_3_inactive_img}/>
                </div>
                Tell Us What You Do
            </p>
            <Form
                className='form-input income-value-limit-styles'
                layout={"vertical"}
                initialValues={{remember: true}}
                form={form}
                onFinish={submitThirdStep}
                disabled={props.isFromSummaryView}
            >
                <Row gutter={[32, 0]}>

                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                            label="Investment Objective"
                            name={"investmentObjectiveID"}
                            rules={!props.isFromSummaryView ?
                                [{required: true, message: 'Please select investment objective'}]: []}>
                            <Select placement='bottomLeft' listHeight={180}
                                    placeholder={"Please select investment objective"}
                                    getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                    style={{width: '100%'}}
                                    onChange={onChangeInvestmentObj}
                            >
                                {
                                    investmentObjective.map((data) => {
                                        return <Option value={data.value}>{data.label}</Option>
                                    })
                                }
                            </Select>
                        </Form.Item>
                        {
                            isInvestmentObjRemark ?
                                <Form.Item
                                    label="Other Investment Objective"
                                    name={"otherInvestmentObjective"}
                                    rules={!props.isFromSummaryView ? [{
                                        required: true,
                                        message: 'Please enter other investment objective'
                                    }]: []}>
                                    <Input placeholder={"Enter other investment objective"}/>
                                </Form.Item> : ''
                        }
                        <Form.Item
                            label="Initial Investment Amount (LKR)"
                            name={"initialInvestmentAmount"}
                            rules={!props.isFromSummaryView ?
                                [{required: true, message: 'Please enter initial investment amount'}]: []}>
                            {/*<NumericFormat customInput={Input}  placeholder={"Enter initial investment amount"}*/}
                            {/*              onChange={onChangeInitialInvestmentAmt}*/}
                            {/*              decimalScale={2} fixedDecimalScale={true}*/}
                            {/*              thousandSeparator="," style={{width: '100%'}}/>*/}
                            {/*<CurrencyFormat  customInput={Input} placeholder={"Enter initial investment amount"}*/}
                            {/*                 onChange={onChangeInitialInvestmentAmt}*/}
                            {/*                decimalScale={2} fixedDecimalScale={true}*/}
                            {/*                thousandSeparator={true}  />*/}

                            {/*<InputNumber maxLength={15} placeholder={"Enter initial investment amount"}*/}
                            {/*             min="0"*/}
                            {/*             step="0.00"*/}
                            {/*             controls={false}*/}
                            {/*             onKeyPress={Validation.isNumber}*/}
                            {/*             onChange={onChangeInitialInvestmentAmt}*/}
                            {/*             parser={(value: any) => value.replace(/\$\s?|(,*)/g, '')}*/}
                            {/*             onBlur={() => toFixedMethod('initialInvestmentAmount')}*/}
                            {/*             style={{width: '100%'}}/>*/}

                            <Input onKeyPress={Validation.isNumber}
                                   maxLength={15}
                                   step="0.00"
                                   onChange={onChangeInitialInvestmentAmt}
                                   onBlur={() => toFixedMethod('initialInvestmentAmount')}
                                   placeholder={"Enter initial investment amount"}/>

                        </Form.Item>
                        <Form.Item
                            label="Expected Future Investment Amount (LKR)"
                            name={"expectedFutureInvestmentAmount"}
                            rules={!props.isFromSummaryView ?
                                [{required: true, message: 'Please enter expected future investment amount'}]: []}>
                            {/*<NumericFormat placeholder={"Enter expected future investment amount"} customInput={Input}*/}
                            {/*              onChange={onChangeExpectedFutureInvestment}*/}
                            {/*              decimalScale={2} fixedDecimalScale={true}*/}
                            {/*              thousandSeparator="," style={{width: '100%'}}/>*/}
                            {/*<CurrencyFormat  placeholder={"Enter expected future investment amount"} customInput={Input}*/}
                            {/*                 onChange={onChangeExpectedFutureInvestment}*/}
                            {/*                 decimalScale={2} fixedDecimalScale={true}*/}
                            {/*                 thousandSeparator={true}  />*/}

                            {/*<InputNumber maxLength={15} placeholder={"Enter expected future investment amount"}*/}
                            {/*             min="0"*/}
                            {/*             step="0.00"*/}
                            {/*             controls={false}*/}
                            {/*             onKeyPress={Validation.isNumber}*/}
                            {/*             onChange={onChangeExpectedFutureInvestment}*/}
                            {/*             parser={(value: any) => value.replace(/\$\s?|(,*)/g, '')}*/}
                            {/*             onBlur={() => toFixedMethod('expectedFutureInvestmentAmount')}*/}
                            {/*             style={{width: '100%'}}/>*/}
                            <Input onKeyPress={Validation.isNumber}
                                   maxLength={15}
                                   onChange={onChangeExpectedFutureInvestment}
                                   onBlur={() => toFixedMethod('expectedFutureInvestmentAmount')}
                                   placeholder={"Enter expected future investment amount"}/>

                        </Form.Item>
                        <Form.Item
                            label="Source of Your Wealth"
                            name={"sourceOfWealthId"}
                            rules={!props.isFromSummaryView ?
                                [{required: true, message: 'Please select source(s) of funds'}]: []}>
                            <Select placement='bottomLeft' listHeight={180}
                                    placeholder={"Please select source(s) of funds"}
                                    getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                    onChange={onChangeSourceOfFund}
                                    style={{width: '100%'}}
                            >
                                {
                                    sourcesOfFunds.map((data) => {
                                        return <Option value={data.value}>{data.label}</Option>
                                    })
                                }
                            </Select>
                        </Form.Item>
                        {
                            isSourceOfFUndRemark ?
                                <Form.Item
                                    label="Other Source of Funds"
                                    name={"otherSourceOfWealth"}
                                    rules={!props.isFromSummaryView ?
                                        [{required: true, message: 'Please enter other source of funds'}]: []}>
                                    <Input placeholder={"Enter other source of funds"}/>
                                </Form.Item> : ''
                        }
                        <Form.Item
                            label="Annual Income"
                            name={"annualIncomeId"}
                            rules={!props.isFromSummaryView ?
                                [{required: true, message: 'Please select annual income'}]: []}>
                            <Radio.Group>
                                <Row gutter={[2, 12]}>
                                    {annualIncome.map((data: DropdownListDto) => {
                                        return (<>
                                            <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                                                <Radio value={data.value}>{data.label}</Radio>
                                            </Col>
                                        </>)
                                    })}
                                </Row>
                            </Radio.Group>
                        </Form.Item>

                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                            name={"occupation"}
                            label="Occupation/ Position Held"
                            onKeyPress={Validation.alphanumericAndSpecialCharactersForOccupation}
                            rules={!props.isFromSummaryView ? [
                                {
                                    required: isFieldsMandatory,
                                    message: 'Please enter occupation/position held'
                                },
                                {
                                    pattern: OCCUPATION_VALIDATION,
                                    message: 'These special characters are not allowed'
                                }
                            ]: []}>
                            <Input placeholder={"Enter occupation/position held"}/>
                        </Form.Item>
                        <Form.Item
                            label="Name of the Employer"
                            name={"nameOfEmployer"}
                            onKeyPress={Validation.alphanumericAndSpecialCharactersForOccupation}
                            rules={!props.isFromSummaryView ? [
                                {
                                    required: isFieldsMandatory,
                                    message: 'Please enter name of the employer'
                                },
                                {
                                    pattern: OCCUPATION_VALIDATION,
                                    message: 'These special characters are not allowed'
                                }
                            ]: []}>
                            <Input placeholder={"Enter name of the employer"}/>
                        </Form.Item>
                        <Form.Item
                            label="Nature of Business"
                            onKeyPress={Validation.alphanumericAndSpecialCharactersForOccupation}
                            name={"natureOfBusiness"}
                            rules={!props.isFromSummaryView ? [
                                {
                                    required: isFieldsMandatory,
                                    message: 'Please enter nature of business'
                                },
                                {
                                    pattern: OCCUPATION_VALIDATION,
                                    message: 'These special characters are not allowed'
                                }
                            ]: []}>
                            <Input placeholder={"Enter nature of business"}/>
                        </Form.Item>
                        <Form.Item
                            label="Address of Employer/ Businesses"
                            name={"addressOfEmployer"}
                            rules={!props.isFromSummaryView ? [isFieldsMandatory ?
                                {
                                    required: true,
                                    message: 'Please enter address of employer/ businesses'
                                } : {required: false}]: []}>
                            <TextArea placeholder={"Enter address of employer/ businesses"}/>
                        </Form.Item>
                        <Form.Item
                            label="Taxpayer Identification Number (TIN)"
                            name={"tinNo"}
                            onKeyPress={Validation.alphanumericAndNumbers}
                            rules={[{
                                max: 12,
                                message: 'The maximum length is 12 characters'
                            },
                                {
                                    pattern: ALPHANUMERIC_AND_NUMBER_VALIDATION,
                                    message: 'These special characters are not allowed'
                                }
                            ]}>
                            <Input style={{width: '100%'}}
                                   placeholder={"Enter taxpayer identification number (TIN)"}/>
                        </Form.Item>
                    </Col>
                </Row>
                {
                    !props.isFromSummaryView ?
                        <>
                            <Row>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Divider></Divider>
                                </Col>
                            </Row>
                            <Space style={{float: 'right'}} className='form_next_btn_col'>
                                <Form.Item>
                                    <Button className='form_next_btn' htmlType="submit" type="primary">
                                        Next
                                    </Button>
                                </Form.Item>
                            </Space>
                        </> : ''
                }
            </Form>

        </div>
    )

}
export default OccupationDetails;

